import { serviceLoading } from 'common/loaderReducer';
import Loader from 'components/Loader';
import * as React from 'react';
import * as _ from 'lodash';
import { InLine, CheckContainer } from './styles';
import { Title, BodyTextCenter, BodyTextLeft,DescriptionContainer, BottomTextContainer, ButtonContainer, Close } from '../Upsell/styles';
import { ModalUpsell }  from '../Upsell';
import { KEYS } from 'common/constants';
import delayUnmounting from 'features/Dealers/DealerConfiguration/Modals/delayUnmounting';
import { getUrlUpgradePackageAPI } from './state/actions';
import upsellupgrade from './upsellupgrade.svg';
import { GET_URLUPGRADE_PACKAGE_API_REQUEST } from './state/actionTypes';
import { TCButton } from 'components/TCButton';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import { RootState } from 'store/types';
import { connect } from 'react-redux';
import { ReactComponent as ExIcon } from 'common/images/search_ex.svg'

export interface ModalUpsellUpgradeProps {
    shouldShow: boolean;
    goToChatMeter: boolean;
    showUpsellSetup: () => void;
    dealerId?: string;
    url?: string;
    UrlUpgradeAPI?: (dealerId?: string) => {};
    isRequesting?: boolean;
    onClose: () => void;
}

export interface ModalUpsellUpgradeStates {
}

class ModalUpsellUpgradePackage extends React.Component<ModalUpsellUpgradeProps, ModalUpsellUpgradeStates> {
    constructor(props) {
        super(props);
    }

    componentWillMount(){
        if (this.props.UrlUpgradeAPI) this.props.UrlUpgradeAPI(this.props.dealerId);
    }

    onUpgradeClick = () => {
        if (!this.props.goToChatMeter) this.props.showUpsellSetup();
        else if (this.props.url) window.open(
                this.props.url??'',
                '_blank'
            );
    }

    keyDownHandle = (e) => {
        if (e.key === KEYS.ENTER) {
            this.onUpgradeClick()
        }
    }

    render() {
        return (
            <ModalUpsell shouldShow={this.props.shouldShow}>
                <Close>
                    <ExIcon onClick={() => this.props.onClose()}/>
                </Close>
                <Title>
                    Listings Manager Advanced
                </Title>
                <DescriptionContainer>
                    <BodyTextCenter>
                    Your listings, reputation, and social media management suite
                    </BodyTextCenter>
                </DescriptionContainer>
                <img src={upsellupgrade} style={{width: 'auto'}}/>
                <BottomTextContainer>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                        Automatically update your business information across 29+ listing and citation sites
                        </BodyTextLeft>
                    </InLine>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                        Publish your specials to Google Business Profile with the click of a button
                        </BodyTextLeft>
                    </InLine>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                        Respond to reviews across different platforms
                        </BodyTextLeft>
                    </InLine>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                        Manage your social media presence
                        </BodyTextLeft>
                    </InLine>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                        Access advanced performance reports
                        </BodyTextLeft>
                    </InLine>
                </BottomTextContainer>
                <ButtonContainer>
                {
                    this.props.isRequesting &&
                    <Loader margin={"10px auto"}/>
                }
                {
                    !this.props.isRequesting &&
                    <TCButton
                        type={TC_BUTTON_TYPE.PRIMARY}
                        onClick={this.onUpgradeClick}
                    >
                        Upgrade Today
                    </TCButton>
                }
                </ButtonContainer>
            </ModalUpsell>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    dealerId: state.dealers.dealer.selectedDealer?.id,
    url: state.dealers.urlUpgradePackage.url,
    isRequesting: serviceLoading(state, [GET_URLUPGRADE_PACKAGE_API_REQUEST])
});

const mapDispatchToProps = (dispatch) => ({
    UrlUpgradeAPI: (dealerId: string) => dispatch(getUrlUpgradePackageAPI(dealerId))
});

export default delayUnmounting<ModalUpsellUpgradeProps>(connect(mapStateToProps,mapDispatchToProps)(ModalUpsellUpgradePackage));
